import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { ProductOrderTemplate } from 'components/Templates'

const ProductOrder: FC = () => {
  return (
    <Layout headline={'sacriで出品する商品の管理'} title={'アプリでの並び順'}>
      <ProductOrderTemplate />
    </Layout>
  )
}

export default ProductOrder
